import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from '@tanstack/react-router';
import Cookies from 'js-cookie';
import { actions } from 'store';



const Logout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		Cookies.remove('authToken');
		dispatch(actions.auth.setState({
			showLoginPage: true,
		}));
		navigate({ to: '/' });
	});

	return null;
};

export default Logout;
